








































import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";
import ResultsAnswerCard from "@/components/results/results-answer-card.vue";

@Component({
  components: {
    ResultsAnswerCard
  }
})
export default class Answers extends Vue {
  get fluid() {
    return vxm.app.fluid;
  }

  get publicResults() {
    return vxm.results.game.publicResults.includes("answers") || vxm.results.isInstructor;
  }

  get isInstructor() {
    return vxm.results.isInstructor;
  }

  get teams() {
    return vxm.results.teams;
  }

  get tasks() {
    return vxm.results.game.tasks;
  }

  async downloadCsv() {
    await vxm.results.downloadAnswers();
  }

  get downloadingCsv() {
    return vxm.results.answersDownloading;
  }
}
